import React from 'react'
import { mergeClassnames } from '@mote/helpers'
import { __DEV__ } from '@mote/helpers/constants'
import styled from '@xstyled/styled-components'

export const TableContainer = React.forwardRef(
  ({ className, as = 'div', ...props }, ref) => {
    return (
      <TableContainerRoot
        ref={ref}
        as={as}
        className={mergeClassnames('mote-table-container', className)}
        {...props}
      />
    )
  }
)

if (__DEV__) {
  TableContainer.displayName = 'TableContainer'
}

const TableContainerRoot = styled.div`
  display: block;
  white-space: nowrap;
  overflow: auto hidden;
  max-width: 100%;
`
